module.exports = __webpack_public_path__ + "static/media/branka.f768f82d.jpg";